import {
  Banner,
  BannerAction,
  BannerContent,
  BannerTitle,
} from '@heidi/design-system/banner';
import { Button } from '@heidi/design-system/button';
import { Info } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { sharedProjectBannerMessages as m } from './SharedProjectBanner.messages';

export interface SharedProjectBannerProps {
  ownerDisplayName?: string | null;
  onContinue?: () => void;
}

export const SharedProjectBanner = ({
  ownerDisplayName,
  onContinue,
}: SharedProjectBannerProps) => {
  const owner = ownerDisplayName?.trim() ?? '';

  return (
    <Banner
      subVariant="subtle"
      role="status"
      data-testid="shared-project-banner"
      className="mb-2 w-full"
    >
      <BannerContent icon={<Info />}>
        <BannerTitle>
          {owner ? (
            <FormattedMessage {...m.sharedBy} values={{ owner }} />
          ) : (
            <FormattedMessage {...m.sharedAnonymous} />
          )}
        </BannerTitle>
      </BannerContent>
      {onContinue ? (
        <BannerAction>
          <Button type="button" variant="outline" size="xs" onClick={onContinue}>
            <FormattedMessage {...m.continueInCopy} />
          </Button>
        </BannerAction>
      ) : null}
    </Banner>
  );
};
